import type { ButtonHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

interface FieldSelectButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "value"
> {
  label: string;
  value: string;
  isActive: boolean;
}

export function FieldSelectButton({
  label,
  value,
  isActive,
  disabled,
  className,
  ...buttonProps
}: FieldSelectButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      className={twMerge(
        "relative flex flex-1 flex-col items-center gap-0.5 px-3 py-2",
        disabled ? "cursor-default" : "cursor-pointer",
        className,
      )}
      {...buttonProps}
    >
      <span className="text-[10px] leading-[15px] font-bold tracking-wide text-[#9CA3AF] uppercase">
        {label}
      </span>
      <span
        className={twMerge(
          "text-[11px] leading-5 font-bold transition-colors",
          isActive ? "text-content-muted" : "text-content-primary",
        )}
      >
        {value}
      </span>
    </button>
  );
}
